import React, { useRef } from "react";
import "./chat-attach.component.scoped.scss";
import { IconButton } from "@material-ui/core";
import AttachFileOutlinedIcon from "@material-ui/icons/AttachFileOutlined";
import { useTranslation } from "react-i18next";

interface ChatAttachProps {
  onFileSelect?: (files: File[] | null) => void;
  disabled?: boolean;
  isMultiple?: boolean;
  accept?: string;
}

const ChatAttach: React.FC<ChatAttachProps> = ({
  onFileSelect,
  disabled = false,
  isMultiple = false,
  accept = '.pdf'
}) => {
  const fileInputRef = useRef<HTMLInputElement>(null);
  const { t } = useTranslation();
  
  const handleAttachClick = () => {
    if (!disabled && fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const files = event.target.files;
    if (files && files.length > 0 && onFileSelect) {
      const fileArray = Array.from(files);
      
      // Check if all files are PDF files
      const validFiles = fileArray.filter(file => file.type === 'application/pdf');
      const invalidFiles = fileArray.filter(file => file.type !== 'application/pdf');
      
      if (invalidFiles.length > 0) {
        console.warn("Only PDF files are allowed");
      }
      
      if (validFiles.length > 0) {
        onFileSelect(validFiles);
      } else {
        onFileSelect(null);
      }
    } else if (onFileSelect) {
      onFileSelect(null);
    }
    
    // Reset the input value so the same files can be selected again
    if (event.target) {
      event.target.value = '';
    }
  };

  return (
    <>
      <input
        ref={fileInputRef}
        type="file"
        accept={accept}
        multiple={isMultiple}
        onChange={handleFileChange}
        style={{ display: 'none' }}
      />
      <IconButton
        className="chat-attach-button"
        onClick={handleAttachClick}
        disabled={disabled}
        size="small"
        title={t("CHATBOT.ATTACH_PDF_FILE")}
        style={{ color: '#1D1A21' }}
      >
        <AttachFileOutlinedIcon style={{ color: '#1D1A21' }} />
      </IconButton>
    </>
  );
};

export default ChatAttach; 